import { render } from "./DBSFacilityCard.vue?vue&type=template&id=4b3cbe50&scoped=true"
import script from "./DBSFacilityCard.vue?vue&type=script&lang=js"
export * from "./DBSFacilityCard.vue?vue&type=script&lang=js"

import "./DBSFacilityCard.vue?vue&type=style&index=0&id=4b3cbe50&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-4b3cbe50"

export default script